const initialsFromFullName = (name) => {
  if (!name?.trim()) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return name.trim().slice(0, 2).toUpperCase();
};

/**
 * Maps a row from POST /v1/user/list `body[]` to UI fields.
 *
 * @param {Record<string, unknown>} raw
 */
export const mapTenantUserListRowToUi = (raw) => {
  if (!raw || typeof raw !== 'object') {
    return {
      id: '',
      fullName: '',
      email: '',
      photo: null,
      status: '',
      roleLabels: [],
      roleSummary: '',
      initials: '?',
      createdAt: null,
    };
  }

  const id =
    (typeof raw.userUuid === 'string' && raw.userUuid) ||
    (typeof raw.user_uuid === 'string' && raw.user_uuid) ||
    '';

  const fullName = typeof raw.fullName === 'string' ? raw.fullName : '';
  const email = typeof raw.email === 'string' ? raw.email : '';
  const photoRaw = typeof raw.photo === 'string' ? raw.photo.trim() : '';
  const photo = photoRaw || null;
  const status = typeof raw.status === 'string' ? raw.status : '';

  const roles = Array.isArray(raw.roles) ? raw.roles : [];
  const roleLabels = roles
    .map((r) => (r && typeof r.roleName === 'string' ? r.roleName.trim() : ''))
    .filter(Boolean);

  let roleSummary = '';
  if (roleLabels.length === 1) roleSummary = roleLabels[0];
  else if (roleLabels.length > 1) roleSummary = `${roleLabels[0]} +${roleLabels.length - 1}`;

  const createdAt =
    (typeof raw.createdAt === 'string' && raw.createdAt) ||
    (typeof raw.created_at === 'string' && raw.created_at) ||
    null;

  return {
    id,
    fullName,
    email,
    photo,
    status,
    roleLabels,
    roleSummary,
    initials: initialsFromFullName(fullName || email),
    createdAt,
  };
};
